import { useState, useEffect } from 'react';

// Canonical meal types live in the backend `meal_types` reference table (#52),
// served at GET /meal-types/. This is the offline fallback so a visit/review
// form never loses its meal picker if that fetch fails — keep it in sync with
// the seed (breakfast, brunch, lunch, dinner, snack, dessert, drinks).
export const FALLBACK_MEAL_TYPES = [
  { slug: 'breakfast', display_name: 'Breakfast' },
  { slug: 'brunch', display_name: 'Brunch' },
  { slug: 'lunch', display_name: 'Lunch' },
  { slug: 'dinner', display_name: 'Dinner' },
  { slug: 'snack', display_name: 'Snack' },
  { slug: 'dessert', display_name: 'Dessert' },
  { slug: 'drinks', display_name: 'Drinks' },
];

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Session-level cache so multiple mounted forms share a single fetch.
let cache = null;

/**
 * Returns the meal types to render in a picker: the reference table from the
 * backend when reachable, otherwise the built-in fallback. Each item is
 * `{ slug, display_name }`; store the `slug` as the value.
 */
export default function useMealTypes() {
  const [mealTypes, setMealTypes] = useState(cache || FALLBACK_MEAL_TYPES);

  useEffect(() => {
    if (cache) return;
    let active = true;
    fetch(`${API_BASE_URL}/meal-types/`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`meal-types ${res.status}`))))
      .then((data) => {
        cache = Array.isArray(data) && data.length ? data : FALLBACK_MEAL_TYPES;
        if (active) setMealTypes(cache);
      })
      .catch((err) => console.error('Falling back to built-in meal types:', err));
    return () => { active = false; };
  }, []);

  return mealTypes;
}
